import s from './children-settings.module.scss'
import { useState } from 'react'
import { Button } from '@shared/ui/button/button'
import { useProfiles } from '@entities/profile/api/useProfiles'
import { ProfileCard } from './ui/profile-card'
import { ProfileFormModal } from './ui/profile-form-modal'

// Управление детскими профилями аккаунта (постановка «Родители и дети»).
export const ChildrenSettings = () => {
	const { data: profiles = [] } = useProfiles()
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingProfile, setEditingProfile] = useState(null)

	const openCreate = () => {
		setEditingProfile(null)
		setIsModalOpen(true)
	}

	const openEdit = (profile) => {
		setEditingProfile(profile)
		setIsModalOpen(true)
	}

	return (
		<div className={s.wrapper}>
			{profiles.length === 0 && (
				<div className={s.empty}>
					У вас пока нет детских профилей. Добавьте ребёнка, чтобы бронировать для него занятия.
				</div>
			)}
			{profiles.map((profile) => (
				<ProfileCard key={profile.id} profile={profile} onEdit={openEdit} />
			))}
			<Button label="Добавить ребёнка" onClick={openCreate} />
			<ProfileFormModal isOpen={isModalOpen} close={() => setIsModalOpen(false)} profile={editingProfile} />
		</div>
	)
}
